import {Component, computed, effect, inject, OnInit, signal} from '@angular/core';
import {RestApiService} from '../../../services/api';
import {AclPermission} from '../../../models/acl/acl-group';
import {SessionStorageService} from '../../../services/session-storage.service';
import {Router, RouterLink} from '@angular/router';
import {Routing} from '../../../models/routing/routing';
import {PanelMenu} from 'primeng/panelmenu';
import {MenuItem} from 'primeng/api';
import {Menu} from 'primeng/menu';
import {Button, ButtonDirective} from 'primeng/button';
import {ResizeService} from '../../../services/resize.service';
import {Badge, BadgeDirective} from 'primeng/badge';

@Component({
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [
        PanelMenu,
        Menu,
        Button,
        ButtonDirective,
        RouterLink,
        BadgeDirective,
        Badge
    ],
    standalone: true
})
export class DashboardComponent implements OnInit {

    protected readonly AclPermission = AclPermission;

    private api = inject(RestApiService);
    private router = inject(Router);
    private resizeService = inject(ResizeService);
    private storage = inject(SessionStorageService);

    monitoredServicesErrors = signal<number>(0);
    menuItems = computed<MenuItem[]>(() => ([
        {
            label: 'Dispositivi SMS',
            routerLink: Routing.remoteDevices.list(),
            icon: 'fa fa-plug',
            visible: this.storage.hasPermission(AclPermission.ViewRemoteDevices)
        },
        {
            label: 'Monitoring',
            routerLink: Routing.monitoring.getBasePath(),
            icon: 'fa-solid fa-heart-pulse',
            badge: this.monitoredServicesErrors().toString(),
            state: {
                mobile: true
            }
        },
    ]));

    constructor() {
    }

    async getMonitoredServicesWithProblems() {
        const servicesStatus = await window.stolcherClient.getServicesStatus(1);
        return servicesStatus.filter(service => service.status !== 'Online');
    }

    async ngOnInit() {
        if (!this.showDashboard()) {
            await this.redirect();
        } else {
            this.loadMonitoredServiceErrors();
        }
    }

    async loadMonitoredServiceErrors() {
        this.monitoredServicesErrors.set((await this.getMonitoredServicesWithProblems()).length);
    }

    showDashboard() {
        return this.resizeService.isMobile();
    }

    async redirect() {
        if (this.storage.hasPermission(AclPermission.ViewTicketsList)) {
            await this.router.navigate([Routing.tickets.list()]);
        } else if (this.storage.hasPermission(AclPermission.ViewAssociatedClientsList)
            || this.storage.hasPermission(AclPermission.ViewAllAssociatedClientsList)) {
            await this.router.navigate([Routing.resellerAgents.agentClients()]);
        }
    }
}
